import React from "react";
import ImageFrame from "./Imageframe";
 
const CapabilityDetail = ({ data, index }) => {
  const reverse = index % 2 === 1;
 
  return (
    <section
      id={`${data.id}-details`}
      className={`gp-detail ${index % 2 === 1 ? "gp-detail--alt" : ""}`}
    >
      <div className="gp-container">
        {/* ---------- Head ---------- */}
        <div className={`gp-detail__head ${reverse ? "is-reverse" : ""}`}>
          <div className="gp-detail__headtext">
            <span className="gp-pill">{data.eyebrow}</span>
            {data.kicker && index !== 0 && (
              <p className="gp-detail__kicker">{data.kicker}</p>
            )}
            <h2 className="gp-detail__title">{data.title}</h2>
            <span className="gp-underline" />
            {data.intro.map((p, i) => (
              <p key={i} className="gp-detail__intro">
                {p}
              </p>
            ))}
          </div>
 
          <ImageFrame
            src={data.image}
            alt={data.eyebrow}
            tag={data.imageTag}
            size="lg"
          />
        </div>
 
        {/* ---------- Feature cards ---------- */}
        <div className="gp-grid">
          {data.blocks.map((b) => (
            <article key={b.title} className="gp-card">
              <h3 className="gp-card__title">{b.title}</h3>
              {b.subtitle && <p className="gp-card__subtitle">{b.subtitle}</p>}
 
              {b.text?.map((t, i) => (
                <p key={i} className="gp-card__text">
                  {t}
                </p>
              ))}
 
              {b.listLabel && <p className="gp-card__label">{b.listLabel}</p>}
 
              {b.list && (
                <ul className="gp-list">
                  {b.list.map((item) => (
                    <li key={item}>{item}</li>
                  ))}
                </ul>
              )}
 
              {b.highlight && (
                <div className="gp-highlight">
                  <strong>{b.highlight.label}:</strong> {b.highlight.text}
                </div>
              )}
 
              {b.note && <p className="gp-card__note">{b.note}</p>}
            </article>
          ))}
        </div>
 
        {/* ---------- Benefits ---------- */}
        {data.benefits && (
          <div className="gp-benefits">
            <h3 className="gp-benefits__title">{data.benefitsTitle}</h3>
            <ul className="gp-benefits__list">
              {data.benefits.map((b) => (
                <li key={b}>
                  <span aria-hidden="true">✓</span> {b}
                </li>
              ))}
            </ul>
          </div>
        )}
 
        {data.closing && <p className="gp-closing">{data.closing}</p>}
      </div>
    </section>
  );
};
 
export default CapabilityDetail;
 